function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandBasin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.660011,
    height: 66.73999,
    viewBox: "0 0 44.660011 66.739993",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-379.10999,-866.95001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 386.07999,897.28003 h 0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M 0,0 V -0.16 H 0.16 V -0.32 H 0.32 V -0.48 -0.64 H 0.48 V -0.8 -0.96 -1.12 -1.28 -1.44 -1.6 -1.76 H 0.32 V -1.92 -2.08 H 0.16 V -2.24 -2.4 L 0,-2.56 H -0.16 V -2.72 H -0.32 -0.48 V -2.88 H -0.64 V -3.04 H -0.8 -0.96 -1.12 -1.28 -1.44 -1.6 -1.76 -1.92 v 0.16 h -0.16 v 0.16 H -2.24 -2.4 v 0.16 h -0.16 v 0.16 h -0.16 v 0.16 l -0.16,0.16 v 0.16 0.16 h -0.16 v 0.16 0.16 0.16 0.16 0.16 0.16 0.16 h 0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(386.07999,897.28002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m 383.20001,896.64001 h 0.15998",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M 0,0 V 0.16 0.32 H 0.16 V 0.48 H 0.32 V 0.64 H 0.48 V 0.8 H 0.64 V 0.96 H 0.8 0.96 L 1.12,1.12 H 1.28 1.44 1.6 1.76 1.92 2.08 L 2.24,0.96 H 2.4 2.56 V 0.8 H 2.72 V 0.64 h 0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(383.20001,896.64001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "M 0,0 H 0.16 0.32 V 0.16 H 0.48 0.64 V 0.32 H 0.8 0.96 V 0.48 0.64 H 1.12 V 0.8 H 1.28 V 0.96 1.12 H 1.44 V 1.28 1.44 1.6 1.76 1.92 2.08 2.24 H 1.28 V 2.4 2.56 H 1.12 V 2.72 2.88 H 0.96 V 3.04 H 0.8 V 3.2 H 0.64 0.48 V 3.36 H 0.32 0.16 0 V 3.52 H -0.16 -0.32 -0.48 -0.64 V 3.36 H -0.8 -0.96 -1.12 V 3.2 H -1.28 -1.44 V 3.04 H -1.6 V 2.88 H -1.76 V 2.72 2.56 H -1.92 V 2.4 2.24 h -0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(385.12,903.03997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M 0,0 V -0.16 -0.32 -0.48 -0.64 -0.8 -0.96 -1.12 H 0.16 V -1.28 -1.44 H 0.32 V -1.6 H 0.48 V -1.76 -1.92 H 0.64 0.8 V -2.08 H 0.96 1.12 V -2.24 H 1.28 1.44 1.6 1.76 V -2.4 l 0.16,0.16 h 0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(383.04001,905.28002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 0,0 0.32,3.36 0.48,3.2 0.8,3.04 1.12,3.04 1.44,3.04 1.6,2.72 1.92,2.720001 L 9.76,23.52",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(387.35999,901.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M 0,0 1.28,0.96 2.56,1.92 4,2.56 5.6,3.04 7.2,3.2 8.8,3.04 10.4,2.72 11.84,2.24",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(396.95999,925.11999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m 0,0 1.76,-0.96 1.6,-1.12 1.44,-1.28 1.44,-1.44 1.12,-1.6 0.96,-1.76 0.8,-1.76 0.48,-1.92 0.32,-2.08 0.16,-1.92",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(408.95999,927.20001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M 419.04001,911.35998 V 889.28003",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "M 0,0 -0.16,-1.92 -0.48,-4 l -0.48,-1.92 -0.8,-1.76 -0.96,-1.76 -1.12,-1.6 -1.44,-1.44 -1.44,-1.28 -1.6,-1.12 -1.76,-0.96",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(419.04001,889.28002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m 0,0 -1.44,-0.48 -1.6,-0.32 -1.6,-0.16 -1.6,0.16 -1.6,0.48 -1.44,0.64 -1.28,0.96 -1.28,0.96",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(408.79999,873.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "M 0,0 -2.08,2.4 -4,5.12 l -1.6,2.72 -1.44,3.04 -1.12,3.04 -0.8,3.039999 -0.48,3.200001 -0.32,3.36",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(397.12,875.67999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "m 423.51999,889.28003 v 22.07995",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m 0,0 2.4,-0.16 2.56,-0.32 2.4,-0.8 2.24,-0.96 2.08,-1.12 2.08,-1.44 1.92,-1.6 1.600001,-1.92 1.439998,-2.08 L 19.84,-12.48 20.799999,-14.72 21.6,-17.120001 21.92,-19.68 l 0.16,-2.4",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(401.44,933.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "m 401.44,933.44 h -19.20001 l -2.88,-2.88 v -60.32001 l 2.88,-3.03998 H 401.44",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "m 0,0 -0.16,-2.4 -0.32,-2.56 -0.8,-2.4 -0.96,-2.24 -1.12,-2.08 -1.44,-2.08 -1.6,-1.92 -1.92,-1.600001 -2.08,-1.439998 L -12.48,-19.84 -14.72,-20.799999 -17.120001,-21.6 -19.68,-21.92 l -2.4,-0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(423.51999,889.28002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M 0,0 H -0.64 L -1.12,0.32 -1.6,0.8 -1.76,1.28 v 0.64 l 0.32,0.48 0.48,0.32 0.64,0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(384.16,898.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "m 383.84,901.91998 h 0.32 l 8.32001,-0.79998",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "m 392.48001,900.96002 0.16,-0.32001 0.15998,-0.32 -0.15998,-0.32001 -0.16,-0.32001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "m 383.84,898.88 8.64001,0.79999 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "m 392.48001,900.96002 0.16,-0.16003 0.15998,-0.15998 v -0.32 V 900 l -0.15998,-0.15997 -0.16,-0.16004",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "M 0,0 1.12,-0.16 2.24,-0.64 3.04,-1.44 3.68,-2.4 4,-3.36 V -4.64 L 3.68,-5.6 3.04,-6.56 2.24,-7.36 1.12,-7.84 0,-8 l -1.12,0.16 -1.12,0.48 -0.8,0.8 -0.64,0.96 -0.32,0.96 v 1.28 l 0.32,0.96 0.64,0.96 0.8,0.8 1.12,0.48 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(397.76001,904.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M 0,0 H -0.64 L -1.28,0.32 -1.6,0.8 -1.76,1.44 -1.6,2.08 -1.28,2.56 -0.64,2.88 H 0",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(384.16,898.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "m 385.28,899.03998 h -0.32001 v -0.32001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "m 385.28,901.76001 -0.32001,0.15997 v -0.15997 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    d: "m 384.95999,901.76001 -0.16,0.32001 v -0.32001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "m 384.95999,901.76001 v 0.15997 l -0.16,0.16004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "m 384.95999,898.71997 -0.16,0.32001 V 898.56 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "m 384.95999,898.71997 v 0.32001 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "m 384.79999,901.76001 -0.47998,0.47998 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "m 384.79999,901.76001 v 0.32001 l -0.47998,0.15997 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "m 384.79999,898.56 -0.47998,0.32 v -0.32 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "m 384.79999,898.56 v 0.47998 L 384.32001,898.88 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "m 384.32001,901.76001 -0.16001,0.64001 v -0.48004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "m 384.32001,901.76001 v 0.47998 l -0.16001,0.16003 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "m 384.32001,898.56 -0.16001,0.32 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "m 384.32001,898.56 v 0.32 H 384.16 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "m 384.16,901.91998 -0.16,0.48004 v -0.48004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "m 384.16,901.91998 v 0.48004 H 384 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "M 384.16,898.40002 384,898.88 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M 384.16,898.40002 V 898.88 H 384 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "m 384,901.91998 -0.16,0.48004 v -0.48004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "m 384,901.91998 v 0.48004 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "m 384,898.40002 -0.16,0.47998 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M 384,898.40002 V 898.88 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "m 383.84,901.91998 -0.16001,0.48004 v -0.48004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "m 383.84,901.91998 v 0.48004 h -0.16001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    d: "m 383.84,898.40002 -0.16001,0.47998 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M 383.84,898.40002 V 898.88 h -0.16001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "m 383.67999,901.91998 -0.16,0.48004 v -0.48004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "m 383.67999,901.91998 v 0.48004 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path115",
    d: "m 383.67999,898.40002 -0.16,0.47998 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M 383.67999,898.40002 V 898.88 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    d: "m 383.51999,901.91998 -0.16,0.32001 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "m 383.51999,901.91998 v 0.48004 l -0.16,-0.16003 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path119",
    d: "m 383.51999,898.40002 -0.16,0.63996 v -0.63996 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M 383.51999,898.40002 V 898.88 l -0.16,0.15998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path121",
    d: "m 383.35999,901.76001 v 0.47998 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 383.35999,898.40002 -0.15998,0.63996 V 898.56 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path123",
    d: "m 383.35999,898.40002 v 0.63996 h -0.15998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "m 383.35999,901.76001 -0.31998,0.47998 v -0.64001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path125",
    d: "m 383.35999,901.76001 v 0.47998 h -0.31998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "m 383.04001,901.59998 v 0.64001 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "m 383.20001,898.56 -0.16,0.64001 V 898.56 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m 383.20001,898.56 v 0.47998 l -0.16,0.16003 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path129",
    d: "m 383.04001,898.56 v 0.64001 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "m 383.04001,901.59998 -0.16001,0.48004 v -0.48004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path131",
    d: "m 383.04001,901.59998 v 0.64001 L 382.88,902.08002 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "m 383.04001,898.56 -0.32001,0.79998 v -0.64001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m 383.04001,898.56 v 0.64001 l -0.32001,0.15997 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "m 382.88,901.59998 -0.16,0.48004 v -0.79999 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m 382.88,901.59998 v 0.48004 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "m 382.72,898.71997 v 0.64001 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path137",
    d: "m 382.72,901.28003 v 0.63995 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "m 382.72,901.28003 v 0.79999 -0.16004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path139",
    d: "m 382.72,898.71997 -0.16,0.80005 V 898.88 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "m 382.72,898.71997 v 0.64001 l -0.16,0.16004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path141",
    d: "m 382.72,901.28003 -0.16,0.63995 V 901.12 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "m 382.72,901.28003 v 0.63995 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path143",
    d: "m 382.56,898.88 -0.16001,0.96003 v -0.80005 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 382.56,898.88 v 0.64002 l -0.16001,0.32001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path145",
    d: "m 382.56,901.12 -0.16001,0.64001 v -0.79999 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "m 382.56,901.12 v 0.79998 l -0.16001,-0.15997 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path147",
    d: "m 382.39999,900.96002 v 0.79999 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "m 382.39999,899.03998 v 0.80005 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path149",
    d: "m 382.39999,899.03998 v 1.11999 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "m 382.39999,899.03998 v 0.80005 0.31994 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path151",
    d: "m 382.39999,900.96002 v 0.79999 -1.12 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "m 382.39999,900.96002 v 0.79999 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path153",
    d: "m 382.39999,900.64001 v 0.95997 -1.27997 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "m 382.39999,900.64001 v 1.12 -0.16003 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path155",
    d: "m 382.39999,899.03998 v 1.28003 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "m 382.39999,899.03998 v 1.11999 0.16004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path157",
    d: "m 382.39999,900.32001 -0.16,1.11999 v -1.11999 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "m 382.39999,900.32001 v 1.27997 l -0.16,-0.15998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path159",
    d: "m 382.39999,899.03998 -0.16,1.28003 v -1.12 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "m 382.39999,899.03998 v 1.28003 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path161",
    d: "m 382.23999,900.32001 -0.16,0.96002 v -0.96002 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M 382.23999,900.32001 V 901.44 l -0.16,-0.15997 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path163",
    d: "m 382.23999,899.20001 -0.16,1.12 v -0.79999 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "m 382.23999,899.20001 v 1.12 h -0.16 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path165",
    d: "m 382.07999,900.32001 -0.15998,0.64001 v -0.64001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "m 382.07999,900.32001 v 0.96002 l -0.15998,-0.32001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path167",
    d: "m 382.07999,899.52002 -0.15998,0.79999 v -0.47998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "m 382.07999,899.52002 v 0.79999 h -0.15998 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path169",
    d: "m 381.92001,900.15997 v 0.16004 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "m 381.92001,900.32001 v 0.32 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "m 381.92001,900.32001 v 0.64001 -0.32001 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "m 381.92001,899.84003 v 0.47998 -0.16004 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path173",
    d: "m 381.92001,899.84003 v 0.47998 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path175",
    d: "m 377.12,992.15997 4.32,6.88001 4.95999,6.72002 5.28,6.24",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "m 383.84,901.91998 8.64001,-0.79998 m 13.28,107.36 v -46.07998",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "m 381.44,989.59998 4.79999,7.52002 5.44,7.04 5.92002,6.72",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path177",
    d: "M 417.28,1019.84 V 951.03998 H 390.56",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M 405.76001,962.40002 390.56,958.56",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path179",
    d: "m 381.28,981.76001 -0.48001,1.11999 -0.31998,1.27997 -0.16,1.28003 0.16,1.27997 0.31998,1.28003 0.48001,1.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M 0,0 -0.8,1.44 -1.28,3.2 -1.6,4.8 -1.76,6.56 -1.6,8.32 -1.28,9.92 -0.8,11.68 0,13.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(377.12,978.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path181",
    d: "m 390.56,958.56 v -7.52002",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "m 391.67999,958.88 -5.28,6.24 -4.95999,6.72003 -4.32,6.87994",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path183",
    d: "M 0,0 1.12,-0.16 2.24,-0.64 3.04,-1.44 3.52,-2.56 3.68,-3.68 3.52,-4.8 3.04,-5.92 2.24,-6.72 1.12,-7.2 0,-7.36 l -1.12,0.16 -1.12,0.48 -0.8,0.8 -0.48,1.12 -0.16,1.12 0.16,1.12 0.48,1.12 0.8,0.8 1.12,0.48 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(390.56,989.11999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "m 397.60001,960 -5.92002,6.56 -5.44,7.20001 -4.79999,7.52002",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path185",
    d: "M 417.28,1019.84 H 390.56",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "m 405.76001,1008.48 -15.20001,3.68 v 7.68",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandBasin);
export default __webpack_public_path__ + "static/media/hand_basin.d3af297461721970ed884c016c985eff.svg";
export { ForwardRef as ReactComponent };